import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Excluir usuário", -1)
const _hoisted_2 = { class: "text-base font-normal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "flex justify-center gap-4" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = { class: "text-base font-normal" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, toRefs } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import SuccessIcon from '@/assets/icons/success.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: ['modalStateProp', 'user'],
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;




const { modalStateProp } = toRefs(props)

const showModalDeleteSuccess = ref(false)

const close = () => {
  emit('close')
}

// TODO: não existe endpoint de exclusão de usuário — o fluxo real de
// desativação usa Network.user.toggleUserStatus (TableUsers). Este modal
// apenas confirma visualmente; o commit Vuex removido mutava dados mock
// de protótipo que nenhuma tela exibia.
const handleDelete = () => {
  showModalDeleteSuccess.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      onClose: close,
      modalActive: _unref(modalStateProp)
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(OutlineButton, {
            width: "119px",
            onClick: close,
            text: "Cancelar"
          }),
          _createVNode(FilledButton, {
            text: "Excluir",
            width: "102px",
            onClick: handleDelete
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(" Tem certeza que deseja excluir o usuário "),
          _createElementVNode("strong", null, _toDisplayString(props.user?.name), 1),
          _createTextVNode("?"),
          _hoisted_3,
          _createTextVNode("Essa ação não poderá ser desfeita! ")
        ])
      ]),
      _: 1
    }, 8, ["modalActive"]),
    _createVNode(ModalVue, {
      onClose: _cache[0] || (_cache[0] = 
      () => {
        showModalDeleteSuccess.value = false
        close()
      }
    ),
      modalActive: showModalDeleteSuccess.value
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SuccessIcon)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(" O "),
          _createElementVNode("strong", null, _toDisplayString(props.user?.name), 1),
          _createTextVNode(" foi excluido"),
          _hoisted_7,
          _createTextVNode("com sucesso! ")
        ])
      ]),
      _: 1
    }, 8, ["modalActive"])
  ], 64))
}
}

})